import { createJob, deleteJob, updateJob } from '@store/JobReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { useAppDispatch, useAppSelector } from '@utils/hooks'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

const Form: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.job)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createJob(values)).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updateJob(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteJob(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

Form.displayName = 'Form'

type FormType = { Form: typeof Form }

export { Form, type FormType }
